import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Incident } from "api";
import { FieldArray, useFormikContext } from "formik";
import get from "lodash/get";
import React, { useMemo } from "react";
import { ChampionshipDriver } from "api/model/Championship/ChampionshipDriver";

const getSelectedDriverOption = (
    option: ChampionshipDriver,
    driver: ChampionshipDriver
) => {
    return option.usedNumber === driver.usedNumber;
};

const onChangeDriver = (push, values: Incident, setFieldValue) => (
    event,
    driver
) => {
    if (driver) {
        push(driver.usedNumber + "");
        if (!values.involvedCars.includes(driver.usedNumber)) {
            const involvedCars = [...values.involvedCars, driver.usedNumber];
            setFieldValue("involvedCars", involvedCars);
        }
    }
};

const getDriverOptionLabel = (driver: ChampionshipDriver) =>
    `#${driver.usedNumber} - ${driver.displayName} (${driver.iracingId})`;

const renderDriverTag = (
    drivers,
    selectedDrivers: string[],
    remove,
    incident: Incident,
    setFieldValue?
) => {
    return drivers.map((driver) => {
        return (
            <Chip
                key={driver.iracingId}
                label={`#${driver.usedNumber} - ${driver.displayName}`}
                size="small"
                color="primary"
                style={{
                    fontSize: 12,
                    marginLeft: 4,
                    marginTop: 2,
                }}
                onDelete={() => {
                    if (
                        setFieldValue &&
                        incident.guiltyCar &&
                        driver.usedNumber === incident.guiltyCar
                    ) {
                        setFieldValue("guiltyCar", "");
                    }
                    remove(selectedDrivers.indexOf(driver.usedNumber));
                }}
            />
        );
    });
};

const renderDriverInput = (label, error) => (params) => {
    return (
        <TextField
            {...params}
            label={label}
            onFocus={(event) => event.currentTarget.select()}
            error={!!error}
            helperText={!!error ? error : ""}
        />
    );
};

interface DriverSelectionProps {
    name: string;
    label: string;
    options: ChampionshipDriver[];
    selected: ChampionshipDriver[];
}

const NotifiedBySelection: React.FC<DriverSelectionProps> = ({
    name,
    label,
    options,
    selected,
}) => {
    const { values, errors, setFieldValue } = useFormikContext<Incident>();
    const error = useMemo(() => get(errors, name), [errors, name]);
    return (
        <FieldArray name={name}>
            {({ push, remove }) => (
                <Box display="flex" flexDirection="column" width="100%">
                    <Autocomplete
                        style={{
                            width: "100%",
                        }}
                        clearOnEscape={true}
                        clearOnBlur={true}
                        clearText="Limpar"
                        getOptionSelected={getSelectedDriverOption}
                        onChange={onChangeDriver(push, values, setFieldValue)}
                        getOptionLabel={getDriverOptionLabel}
                        options={options}
                        renderInput={renderDriverInput(label, error)}
                    />
                    <Box display="flex" alignItems="center" flexWrap="wrap">
                        {renderDriverTag(
                            selected,
                            values.notifiedBy,
                            remove,
                            values
                        )}
                    </Box>
                </Box>
            )}
        </FieldArray>
    );
};

export { NotifiedBySelection };
